import {createMultiStyleConfigHelpers} from '@chakra-ui/react'
import {remCalc} from '../../_utils'

const helpers = createMultiStyleConfigHelpers([
    'header',
    'cart',
    'policies',
    'support',
    'paymentMethods',
    'shipping',
    'emptyCart',
])

const Cart = helpers.defineMultiStyleConfig({
    baseStyle: (props) => ({
        header: {
            headerContainer: {
                display: 'flex',
                flexDir: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                width: '100%',
            },
            stack: {
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
            },
            title: {
                color: 'foreground.neutral.default',
                textStyle: 'head-xlarge',
                fontFamily: 'heading',
                fontWeight: 'light',
            },
            quantity: {
                color: 'foreground.neutral.muted',
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
        },
        shipping: {
            shippingContainer: {
                bg: 'background.base.under',
                w: '100%',
                display: 'flex',
                flexDir: 'row',
                padding: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
                alignItems: 'center',
                justifyContent: 'space-between',
                borderRadius: 'large-1',
            },
            shippingContent: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                gap: remCalc(8),
            },
            shippingIcon: {
                width: remCalc(14),
                height: remCalc(14),
            },
            shippingText: {
                color: 'foreground.neutral.default',
                textStyle: 'body-small',
                fontWeight: 'medium',
            },
            closeIcon: {
                boxSize: 'iconsSize.small',
            },
        },
        cart: {
            outerContainer: {
                flex: 1,
                width: '100%',
                bg: 'background.base.default',
            },
            boxContainer: {
                display: 'flex',
                flexDir: 'column',
                paddingX: {
                    md: remCalc(40),
                    base: remCalc(16),
                },
                paddingTop: remCalc(40),
                width: '100%',
                maxW: remCalc(1432),
                h: 'auto',
                alignItems: 'flex-start',
                gap: remCalc(10),
                alignSelf: 'stretch',
                margin: '0 auto',
            },
            headerFlex: {
                flexDir: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: {
                    base: 'xsmall-1.base',
                    md: 'xsmall-1.md',
                    lg: 'xsmall-1.lg',
                    xl: 'xsmall-1.xl',
                },
                alignSelf: 'stretch',
            },
            cartMainStack: {
                spacing: remCalc(24),
                w: '100%',
            },
            cartContainer: {
                minWidth: '100%',
                height: '100%',
                paddingTop: {
                    lg: remCalc(8),
                    md: remCalc(8),
                    sm: remCalc(8),
                    base: remCalc(8),
                },
                paddingBottom: {
                    lg: remCalc(14),
                    md: remCalc(14),
                    sm: remCalc(8),
                    base: remCalc(8),
                },
            },
            containerGrid: {
                gap: ['small.base', 'small.sm', 'small.md', 'small.lg'],
                templateColumns: {base: '1fr', lg: '3fr 1fr'},
                templateRows: {lg: 'auto auto'},
            },
            checkoutItem: {
                display: 'flex',
                p: remCalc(24),
                flexDir: 'column',
                borderRadius: 'medium.lg',
                bg: 'background.light',
            },
            checkoutItemWhite: {
                display: 'flex',
                p: remCalc(24),
                flexDir: 'column',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                borderRadius: 'medium.lg',
                bg: 'background.default',
            },
            orderSummaryContainer: {
                width: {base: 'full', lg: remCalc(450)},
            },
        },
        emptyCart: {
            pageContainer: {
                layerStyle: 'page',
                display: 'flex',
                flexDir: 'column',
                w: '100%',
                h: 'auto',
                alignItems: {
                    lg: 'center',
                    md: 'center',
                    sm: 'flex-start',
                    base: 'flex-start',
                },
                gap: remCalc(10),
                alignSelf: 'stretch',
                paddingY: 0,
                px: '0 !important',
            },
            cartContainer: {
                display: 'flex',
                flexDir: {
                    lg: 'row',
                    md: 'column',
                    sm: 'column',
                    base: 'column',
                },
                alignItems: 'center',
                justifyContent: {
                    lg: 'center',
                },
                paddingY: {
                    lg: 0,
                    md: 0,
                    base: remCalc(24),
                },
                gap: remCalc(24),
                w: '100%',
                h: 'auto',
                flexWrap: {
                    sm: 'stretch',
                    base: 'stretch',
                },
            },
            leftStack: {
                flex: '2',
                spacing: 0,
                align: 'stretch',
                alignSelf:
                    props.removeMessagesLength > 0
                        ? ['center', 'center', 'center', 'flex-start']
                        : 'auto',
                maxWidth: [remCalc(451), remCalc(451), remCalc(451), 'unset'],
                width: '100%',
            },
            headerContainer: {
                display: 'flex',
                flexDir: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                padding: remCalc(40),
            },
            cartContent: {
                display: 'flex',
                flexDir: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'stretch',
                width: 'auto',
                h: '100%',
                minHeight: remCalc(420),
                gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            },
            removeMessagesBox: {
                pb: 'medium.base',
                alignItems: 'flex-start',
                textAlign: 'left',
                w: '100%',
            },
            checkoutContainer: {
                display: 'flex',
                flex: '2',
                maxWidth: remCalc(451),
                h: 'auto',
            },
            emptyStack: {
                gap: remCalc(24),
            },
            emptyIconContainer: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: remCalc(14),
                borderRadius: 'large-1',
                bg: 'background.base.under',
            },
            emptyIcon: {
                w: remCalc(16),
                h: remCalc(16),
            },
            discoverMoreButton: {
                padding: remCalc(14),
            },
            textContainer: {
                display: 'flex',
                flexDir: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
            },
            emptyCartTitle: {
                color: 'foreground.neutral.default',
                textAlign: 'center',
                textStyle: 'body-medium',
                fontWeight: 'medium',
            },
            emptyCartDescription: {
                color: 'foreground.neutral.subtle',
                textStyle: 'body-medium',
                fontWeight: 'normal',
                textAlign: 'center',
            },
            productsContainer: {
                display: 'flex',
                flexDir: 'row',
                alignSelf: 'flex-start',
                paddingBottom: 'medium.lg',
                width: 'auto',
                h: 'auto',
                pX: {
                    lg: 0,
                    md: 0,
                    sm: 'medium.sm',
                    base: 'medium.base',
                },
                pY: 0,
                gap: remCalc(24),
            },
        },
        policies: {
            outerContainer: {
                display: 'flex',
                flexDir: 'column',
                alignItems: 'flex-start',
                justifyContent: 'flex-start',
                w: '100%',
                gap: remCalc(8),
            },
            policiesContainer: {
                w: '100%',
                bg: 'background.base.default',
                padding: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
                border: '1px solid var(--chakra-colors-border-neutral-subtle)',
                borderRadius: 'large-1',
            },
            section: {
                color: 'foreground.neutral.default',
                align: 'start',
                display: 'flex',
                flexDir: 'column',
                alignItems: 'flex-start',
                alignSelf: 'stretch',
            },
            header: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(10),
                alignSelf: 'stretch',
            },
            title: {
                textStyle: 'body-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            message: {
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
            icon: {
                w: remCalc(14),
                h: remCalc(14),
            },
            link: {
                textDecoration: 'underline',
            },
        },
        support: {
            additionalInfoCardContainer: {
                flexDir: 'column',
                gap: remCalc(8),
                paddingTop: remCalc(8),
            },
            supportContainer: {
                gap: remCalc(24),
                alignItems: 'left',
            },
            supportEmailSection: {
                justifyContent: 'space-between',
                alignItems: 'center',
                alignContent: 'center',
                rowGap: remCalc(24),
                alignSelf: 'stretch',
                flexWrap: {
                    lg: 'wrap',
                    md: 'wrap',
                    sm: 'no-wrap',
                    base: 'no-wrap',
                },
            },
            innerEmailStack: {
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                gap: remCalc(24),
                flexWrap: 'wrap',
            },
            supportChatSection: {
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                gap: remCalc(24),
                flexWrap: 'wrap',
            },
            supportIcon: {
                w: 'iconsSize.xlarge',
                h: 'iconsSize.xlarge',
                color: 'button.text.text-default',
            },
            text: {
                minWidth: remCalc(100),
                maxWidth: remCalc(168),
                flex: '1 0 0',
                color: 'text.secondary',
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
            discoverMoreButton: {
                textStyle: 'body-xsmall',
                fontWeight: 'bold',
            },
            supportText: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(4),
                color: 'foreground.neutral.subtle',
                textStyle: 'body-small',
                fontWeight: 'normal',
            },
        },
        paymentMethods: {
            stack: {
                alignItems: 'flex-start',
                gap: remCalc(24),
                alignSelf: 'stretch',
            },
            headerContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(10),
                alignSelf: 'stretch',
            },
            header: {
                color: 'text.default',
                textStyle: 'head-xsmall',
                fontWeight: 'medium',
            },
            iconsContainer: {
                display: 'flex',
                alignItems: 'center',
                alignContent: 'center',
                gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
                alignSelf: 'flex-start',
                flexWrap: 'wrap',
            },
            iconContainer: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                w: remCalc(36),
                h: remCalc(24),
                paddingY: {
                    base: 'xxsmall.base',
                    md: 'xxsmall.md',
                    lg: 'xxsmall.lg',
                    xl: 'xxsmall.xl',
                },
                paddingX: {
                    base: 'xxxsmall-1.base',
                    md: 'xxxsmall-1.md',
                    lg: 'xxxsmall-1.lg',
                    xl: 'xxxsmall-1.xl',
                },
                bg: 'background.base.default',
                borderRadius: 'large',
                boxShadow:
                    '0 0 0 0.75px var(--chakra-colors-border-neutral-highlight) inset, 0 0.75px 1.5px 0 var(--chakra-shadows-neutral-xs), 0 0 0 0.75px var(--chakra-shadows-neutral-xs)',
            },
            icon: {
                w: '100%',
                bg: 'background.base.default',
            },
        },
    }),
    variants: {
        checkout: {
            cart: {
                checkoutItem: {
                    display: 'flex',
                    p: remCalc(24),
                    flexDir: 'column',
                    borderRadius: 'medium.lg',
                    bg: 'background.light',
                    mt: remCalc(8),
                },
            },
            paymentMethods: {
                iconsContainer: {
                    paddingTop: {
                        base: 'small.base',
                        md: 'small.md',
                        lg: 'small.lg',
                        xl: 'small.xl',
                    },
                },
            },
        },
    },
})
export default Cart
